import {Component, Input, Output, EventEmitter} from '@angular/core';
import {ShareButtons, ShareButtonsModule} from 'ngx-sharebuttons/buttons';
import {environment} from 'src/environments/environment';
import {ActivatedRoute} from '@angular/router';
import {Clipboard} from '@angular/cdk/clipboard';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CustomChartService} from "../../../../services/custom-chart/custom-chart.service";

@Component({
  selector: 'app-chart-share-dialog',
  templateUrl: './chart-share-dialog.component.html',
  styleUrls: ['./chart-share-dialog.component.scss'],
  standalone: true,
  providers: [ShareButtons],
  imports: [
    ShareButtonsModule
  ]
})
export class ChartShareDialogComponent {

  constructor(
    private route: ActivatedRoute,
    private clipboard: Clipboard,
    private snack: MatSnackBar,
    private customChartService: CustomChartService,
  ) {
  }

  @Input() app: string = 'rdna';
  @Input() header: string = 'Dialog header';
  @Input() body: string = 'Dialog body';
  @Input() footer: string = 'Dialog footer';
  @Input() chart: any = null;
  @Output() closeDialog = new EventEmitter<void>();

  buttons_to_include = ["linkedin", "facebook", "twitter", "email", "copy"]
  shareUrl: any = null;
  embedCode: any = null;
  customChartID: number | null = null;
  customChartCreated: boolean = false;

  async ngOnInit() {
    let params = this.route.snapshot.queryParamMap


    if (this.app === 'rdna') {
      const chartID = `RXI-${this.chart.rcl}-${this.chart.id}`
      console.log(this.chart)

      const createdChartID = await this.createCCAndGetID(chartID, this.chart);
      if (this.customChartCreated) {
        this.shareUrl = `${environment.frontend_base}shared/?s=rcl&id=${this.chart.rcl}-${this.chart.id}&custom_id=${this.customChartID}`;
        this.customChartCreated = false;
      } else {
        if (this.route.snapshot.routeConfig?.path !== 'shared') {
          if (this.route.snapshot.routeConfig?.path === 'saved-charts') {
            if (this.customChartID) {
              this.shareUrl = `${environment.frontend_base}shared/?s=rcl&id=${this.chart.rcl}-${this.chart.id}&custom_id=${this.customChartID}`;
            } else {
              this.shareUrl = `${environment.frontend_base}shared/?s=rcl&id=${this.chart.rcl}-${this.chart.id}`
            }
          } else {
            if (this.customChartID) {
              let paramId = params.get('id')
              this.shareUrl = `${environment.frontend_base}shared/?s=rcl&id=${paramId}-${this.chart.id}&custom_id=${this.customChartID}`;
            } else {
              let paramId = params.get('id')
              this.shareUrl = `${environment.frontend_base}shared/?s=rcl&id=${paramId}-${this.chart.id}`
            }
          }

        }
        else if (params.has('s')) {
          if (this.customChartID) {
            let paramId = params.get('id')
            this.shareUrl = `${environment.frontend_base}shared/?s=rcl&id=${paramId}&custom_id=${this.customChartID}`;
          } else {
            let paramId = params.get('id')
            this.shareUrl = `${environment.frontend_base}shared/?s=rcl&id=${paramId}`
          }

        }
      }


    }
    else if (this.app === 'lb') {
      const chartID = `RXI-SQA-${this.chart.sqa_chart_id}`
      const createdChartID = await this.createCCAndGetID(chartID, this.chart); // Wait for the API call


      if (this.customChartCreated) {
        this.shareUrl = `${environment.frontend_base}shared/?s=sqa&id=${this.chart.sqa_chart_id}&custom_id=${this.customChartID}`;
        this.customChartCreated = false;
      }
      else {
        if (this.route.snapshot.routeConfig?.path !== 'shared') {

            this.shareUrl = `${environment.frontend_base}shared/?s=sqa&id=${this.chart.sqa_chart_id}`

            this.shareUrl = `${environment.frontend_base}shared/?s=sqa&id=${this.chart.sqa_chart_id}`
        }
        else if (params.has('s')) {
          let paramId = params.get('id')
          this.shareUrl = `${environment.frontend_base}shared/?s=sqa&id=${paramId}`
        }
      }
    }
  }

  createCCAndGetID(chartID: any, chartObj: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (chartObj.customChartJson) {
        this.customChartService.createCustomChart(chartID, chartObj.customChartJson).subscribe(
          (response) => {
            this.customChartID = response.id;
            chartObj.customChartJson = null;
            this.customChartCreated = true;
            resolve(true); // Resolve with true if successful
          },
          (error) => {
            console.error('Error creating custom chart and getting ID:', error.error.error);
            reject(error);
          }
        );
      } else {
        console.log('No custom chart content found');
        resolve(false); // Resolve with false if no chart is created
      }
    });
  }

  destroyMe() {
    this.closeDialog.emit()
  }

  copyEmbedCode(type: string) {
    let width = ''
    let height = ''

    if (type === 'fixed') {
      width = '600px'
      height = '500px'
    } else if (type === 'responsive') {
      width = '100%'
      height = '100%'
    }

    this.embedCode = `<iframe frameborder="0" style='width:${width};height:${height};' src='${this.shareUrl}'></iframe>`
    this.clipboard.copy(this.embedCode)
    let snackRef = this.snack.open('The embedding code has been copied to your clipboard', 'Accept')

    snackRef._dismissAfter(3000)

  }
}
